module.exports = __webpack_public_path__ + "img/clock.b3b92583.png";